// extracted by mini-css-extract-plugin
export var divider = "_o6-0";
export var systemMessage = "_o6-1";
export var systemMessageWrapper = "_o6-2";